module.exports = __webpack_public_path__ + "img/public/siteImages/stepFooter.svg?8f7f8ae3";